import { Component, Ref, SimpleEvent } from '@eastsideco/salvo-ts';
import { ThemeComponent } from "@/theme/ThemeComponent";

@Component
export class MobileMenu extends ThemeComponent {
    @Ref({required: false}) stateTrigger!: HTMLElement[];
    @Ref({required: false}) stateNav!: HTMLElement[];
    @Ref({required: false}) grandchildToggle!: HTMLButtonElement[];
    @Ref({required: false}) overlay!: HTMLDivElement;

    private open: string = '';
    private _onOpenChange = new SimpleEvent<string>();

    public get onOpenChange() {
        return this._onOpenChange.asEvent();
    }

    public changeOpen(open: string) {
        this.open = open;

        // Use the private backing field to dispatch
        this._onOpenChange.dispatch(open);
    }
    /**
     * Initialise.
     */
    init() {
        this.eventListeners();
        this.setEventListeners();
        this.setResizeListener();
    }

    /**
     * Event Listeners
     */
    eventListeners() {
        this.openMenu();
    }

    /**
     * Toggle Mobile Menu.
     */
    openMenu() {
        document.addEventListener('openMenu', () => {
            this.classList.toggle('is-active');
            this.overlay.classList.toggle('is-active');
        });
    }

    /**
     * Set event listeners.
     */
    setEventListeners() {
        if (this.stateTrigger.length > 0) {
            for(const trigger of this.stateTrigger) {
                this.$listen(trigger, 'click', () => {
                    this.handleStateChange(trigger, trigger.dataset.child);
                });
            }
        }

        if (this.grandchildToggle.length > 0) {
            for(const toggle of this.grandchildToggle) {
                this.$listen(toggle, 'click', () => {
                    toggle.classList.toggle('is-active');
                    toggle.nextElementSibling?.classList.toggle('is-active');
                });
            }
        }

        if (this.overlay) {
            this.$listen(this.overlay, 'click', () => {
                this.classList.remove('is-active');
                this.overlay.classList.remove('is-active');
            });
        }
    }

    /**
     * Handle multistate menu change.
     * @param child - trigger child menu handle
     */
    handleStateChange(parent: HTMLElement, child: string|undefined) {
        if (this.stateTrigger.length === 0) { return; }

        for(const nav of this.stateNav) {
            nav.classList.remove('is-active');
            if (nav.dataset.parent === child) {
                nav.classList.add('is-active');
            }
        }

        for(const trigger of this.stateTrigger) {
            trigger.classList.remove('is-active');
            if (trigger === parent) {
                trigger.classList.add('is-active');
            }
        }
    }

    /**
     * Set resize listener to close the menu on window resize.
     */
    setResizeListener() {
        window.addEventListener('resize', () => {
            this.classList.remove('is-active');
            if (this.overlay) {
                this.overlay.classList.remove('is-active');
            }
        });
    }
}
